import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBook = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 3.75v12.99m-1.42.195 1.045.253c.139.034.208.05.278.057.065.007.13.007.194 0 .07-.007.14-.023.278-.057l1.044-.253c.348-.084.522-.126.695-.162a10.006 10.006 0 0 1 4.022 0c.173.036.347.078.695.162.166.04.249.06.316.067a1 1 0 0 0 1.094-.86c.009-.066.009-.151.009-.322V4.499c0-.24 0-.36-.023-.466a1 1 0 0 0-.54-.686c-.097-.047-.214-.075-.448-.132-.753-.183-1.13-.274-1.508-.335a10.008 10.008 0 0 0-3.212 0c-.378.061-.755.152-1.508.335l-.636.154c-.139.034-.208.05-.278.057a1 1 0 0 1-.194 0 2.089 2.089 0 0 1-.278-.057l-.635-.154c-.754-.183-1.131-.274-1.51-.335a10.008 10.008 0 0 0-3.21 0c-.379.061-.756.152-1.51.335-.233.057-.35.085-.447.132a1 1 0 0 0-.54.686c-.023.105-.023.225-.023.466v11.32c0 .171 0 .257.009.323a1 1 0 0 0 1.094.86c.067-.006.15-.027.316-.067.348-.084.522-.126.695-.162a10.007 10.007 0 0 1 4.022 0c.173.036.347.078.695.162Z"
	})]
});
const ForwardRef = forwardRef(SvgBook);
export { ForwardRef as ReactComponent };
